import { gql } from '@apollo/client';
import { FileType } from '@jbc-year-end-adj/2024/types';

export type FormerJob = {
  id: string;
  companyName: string;
  resignedOn: string;
  lastSalaryOn?: string;
  withholdingSlipStatus: 'submitted' | 'not_submitted' | 'unavailable' | 'in_order';
  deductionAmount?: string;
  paymentAmount?: string;
  taxAmount?: string;
  withholdingSlipImage?: FileType | undefined;
  address?: string;
};

export const FORMER_JOBS_FRAGMENT = gql`
  fragment FormerJobs on Profile {
    formerJobs {
      id
      companyName
      address
      lastSalaryOn
      resignedOn
      withholdingSlipStatus
      deductionAmount
      paymentAmount
      taxAmount
      compareKey
      withholdingSlipImage {
        url
        filename
      }
    }
  }
`;

export const FORMER_JOBS = gql`
  query formerJobs {
    request {
      id
      profile {
        id
        ...FormerJobs
      }
    }
  }
  ${FORMER_JOBS_FRAGMENT}
`;

export const EMPLOYEE_OFFICE = gql`
  query employeeOffice {
    request {
      id
      employee {
        id
        office {
          id
          name
        }
      }
    }
  }
`;

export const IMAGE_SETTINGS = gql`
  query employeeYear {
    request {
      id
    }
    clientSetting {
      id
      requestImageUploadSettings {
        previousWithholdingSlip
      }
    }
  }
`;
